// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section_Section__1BcTP","Grey":"Section_Grey__X8XwM"};